import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { StudentAssignmentProgressEvent, studentAssignmentProgress } from "../models/student-assignment-progress-event.model";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { ResetStudentAssignmentRequest } from "../models/reset-student-assignment-request.model";
import { StudentCourseProgressRequest } from "../models/student-course-progress-request.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";

@DwAction({
    keyName: 'student-update-course-progress',
    display: 'Student - Update Course Progress',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.StudentCourse,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Update Course Progress',
        iconClass: 'fa fa-tasks',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Updates the course progress for the student and creates an missing endorsements'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.studentCourseCanResetProgress,
        requireCanUpdate: true
    },
    defaultConfirmConfig :{
        showDialogConfig: true,
        showConfirmDialog: true,
        message: 'Are you sure?  This cannot be undone!',
        title: 'Update Course Progress for Student'
    }
})
@Injectable()
export class StudentUpdateCourseProgressActionService implements DwMdFormActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private schoolRespositoryService: SchoolRepositoryService,
        private dwEventService: DwEventService
    ) {
        
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {

        const studentCourse = actionState.formApi.getFormData<StudentCourseEntity>();

        const request: StudentCourseProgressRequest = {
            studentCourseId: studentCourse.StudentCourseId,
            forceUpdate: true,
        };

        return this.schoolRespositoryService.updateStudentCourseProgress(request)
            .pipe(map((resetResult) => {
                const result: DwActionResult = {
                    success: resetResult.IsSuccess
                };

                if (resetResult.ErrorMessage) {
                    result.message = `Error updating student progress  Error: ${resetResult.ErrorMessage} `
                } else {
                    result.message = 'Student progress updated successfully';

                    actionState.formApi.cancel();
                }
        
                return result;
            }));
    }
}